<template>
    <section class="">        
        <article v-for='prj in zh_only(contents)' :key='prj.header.title'  class="message">
          <div class="message-header">
            <p v-html='subtitle(prj.header)'></p>
          </div>
          <div class="message-body">
            <h4 class="title">{{prj.header.title}}</h4>
            <h6 class="subtitle"><md :source='prj.body.split("\n")[0]'></md></h6>
            <div class="content"><md :source='prj.body'></md></div>    
        </div>
        </article>
    </section>
</template>

<script>
import md from "../components/mdify.vue";

export default {
  props: ["contents"],
  data() {
    return {};
  },
  methods: {
    complete_url(img) {
      return "dist/img/" + img;
    },
    subtitle(header){
      return [header.duration.start, header.keywords].join(' &middot; ');
      },
    zh_only: function(items) {
      const temp = items.slice(); //copy to evade infinite loop, see https://github.com/vuejs/vue/issues/1153
        return items.filter(function(item) {
          return item.header.language == 'zh';
        });
        }
    },
  components: {
    md
  }
};
</script>


<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/landing_projects.vue